import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_engagement_fye_employee_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  engagement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fye_hdr_guid: fromDatatype.GuidDataFieldInterface;
  employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  billing_rate_per_day: fromDatatype.NumericDatatypeInterface;
  billing_rate_per_month: fromDatatype.NumericDatatypeInterface;
  expense_rate_per_day: fromDatatype.NumericDatatypeInterface;
  expense_rate_per_month: fromDatatype.NumericDatatypeInterface;
  est_hours_per_month: fromDatatype.NumericDatatypeInterface;
  engagement_role: fromDatatype.VarcharDatatypeInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  approval_level: fromDatatype.NumericDatatypeInterface;
  rank: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_engagement_fye_employee_link_RowClass implements bl_aat_engagement_fye_employee_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  engagement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fye_hdr_guid: fromDatatype.GuidDataFieldInterface;
  employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  billing_rate_per_day: fromDatatype.NumericDatatypeInterface;
  billing_rate_per_month: fromDatatype.NumericDatatypeInterface;
  expense_rate_per_day: fromDatatype.NumericDatatypeInterface;
  expense_rate_per_month: fromDatatype.NumericDatatypeInterface;
  est_hours_per_month: fromDatatype.NumericDatatypeInterface;
  engagement_role: fromDatatype.VarcharDatatypeInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  approval_level: fromDatatype.NumericDatatypeInterface;
  rank: fromDatatype.VarcharDatatypeInterface;
}
